module.exports = __webpack_public_path__ + "static/media/ic_trash.e29b66e6.svg";